import { render, staticRenderFns } from "./FieldPrices.vue?vue&type=template&id=055abed4&"
import script from "./FieldPrices.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FieldPrices.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055abed4')) {
      api.createRecord('055abed4', component.options)
    } else {
      api.reload('055abed4', component.options)
    }
    module.hot.accept("./FieldPrices.vue?vue&type=template&id=055abed4&", function () {
      api.rerender('055abed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/FieldPrices/FieldPrices.vue"
export default component.exports